import { DependencyList, useEffect } from 'react';

export const useAsyncEffect = (
  asyncEffect: (abort: { value: boolean }) => void,
  deps: DependencyList
) => {
  useEffect(() => {
    const abort = { value: false };
    asyncEffect(abort);
    return () => {
      abort.value = true;
    };
  }, deps); // eslint-disable-line react-hooks/exhaustive-deps
};
